module.exports = __webpack_public_path__ + "static/media/spanish-imperative-table1.5016b4cd.PNG";